import { HttpMethods, sendRequest } from "../util/ApiHelper"

const CONTROLLER_NAME = "Translations";

export const getAllTranslations = async () => {
    return await sendRequest(
        HttpMethods.GET,
        `${CONTROLLER_NAME}/GetAllTranslations`
    );
}